import React from 'react';
import type { LeadSource } from '@troia-v3/types';

import { Icon } from '../Icon';

import { LEAD_SOURCE_CATALOG } from './catalog';

export interface LeadSourceIconProps {
  /** Source canônica do lead (enum `LeadSource` em @troia-v3/types). */
  source: LeadSource;
  /** Tamanho em px. Default 16. */
  size?: number;
  /** Classe extra opcional. */
  className?: string;
  /** Cor sólida. Default herda `currentColor` do parent. */
  color?: string;
}

/**
 * Ícone canônico para uma source de lead.
 *
 * Renderiza o logo da marca quando disponível (Meta, Google, TikTok via
 * @icons-pack/react-simple-icons) ou um ícone Feather equivalente
 * (LinkedIn → linkedin, Orgânico → globo, Email → envelope, etc.).
 *
 * Cor: por padrão `currentColor` (herda do parent). Para forçar a cor TROIA:
 * `color="#7c3aed"` ou `color="var(--theme-primary)"`.
 *
 * Uso:
 * ```tsx
 * <LeadSourceIcon source="meta" size={16} color="#7c3aed" />
 * ```
 */
export const LeadSourceIcon: React.FC<LeadSourceIconProps> = ({
  source,
  size = 16,
  className,
  color,
}) => {
  const entry = LEAD_SOURCE_CATALOG[source];

  if (entry.kind === 'simple-icon') {
    const SiComponent = entry.icon;
    return (
      <SiComponent
        size={size}
        className={className}
        color={color ?? 'currentColor'}
        title={entry.label}
      />
    );
  }

  return (
    <Icon
      name={entry.iconName}
      size={size}
      className={className}
      style={color ? { color } : undefined}
      aria-label={entry.label}
    />
  );
};

LeadSourceIcon.displayName = 'LeadSourceIcon';
